import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../service/auth.service';
import { YukkApi } from 'src/app/service/yukkapi.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../service/config.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, tap, startWith } from 'rxjs/operators';
import * as XLSX from 'xlsx';

/**
* This is the dialog for ask some particular entity that not exist in the cockpit.
*/

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-entityask',
  templateUrl: './entityask.component.html',
  styleUrls: ['./entityask.component.scss']
})
export class EntityaskComponent {

  // switching between tabs 'Add Single Entity' and 'Upload Excel File'
  headerTab = 'single';

  sectorsList = [];

  // sectorsList = [
  //   'Exploration & Production',
  //   'Integrated Oil & Gas',
  //   'Oil Equipment & Services',
  //   'Pipelines',
  //   'Renewable Energy Equipment',
  //   'Alternative Fuels',
  //   'Commodity Chemicals',
  //   'Specialty Chemicals',
  //   'Forestry',
  //   'Paper',
  //   'Aluminum',
  //   'Nonferrous Metals',
  //   'Iron & Steel',
  //   'Coal',
  //   'Diamonds & Gemstones',
  //   'General Mining',
  //   'Gold Mining',
  //   'Platinum & Precious Metals',
  //   'Building Materials & Fixtures',
  //   'Heavy Construction',
  //   'Aerospace',
  //   'Defense',
  //   'Containers & Packaging',
  //   'Diversified Industrials',
  //   'Electrical Components & Equipment',
  //   'Electronic Equipment',
  //   'Commercial Vehicles & Trucks',
  //   'Industrial Machinery',
  //   'Delivery Services',
  //   'Marine Transportation',
  //   'Railroads',
  //   'Transportation Services',
  //   'Trucking',
  //   'Business Support Services',
  //   'Business Training & Employment Agencies',
  //   'Financial Administration',
  //   'Industrial Suppliers',
  //   'Waste & Disposal Services',
  //   'Automobiles',
  //   'Auto Parts',
  //   'Tires',
  //   'Brewers',
  //   'Distillers & Vintners',
  //   'Soft Drinks',
  //   'Farming & Fishing',
  //   'Food Products',
  //   'Durable Household Products',
  //   'Nondurable Household Products',
  //   'Furnishings',
  //   'Home Construction',
  //   'Consumer Electronics',
  //   'Recreational Products',
  //   'Toys',
  //   'Clothing & Accessories',
  //   'Footwear',
  //   'Personal Products',
  //   'Tobacco',
  //   'Health Care Providers',
  //   'Medical Equipment',
  //   'Medical Supplies',
  //   'Biotechnology',
  //   'Pharmaceuticals',
  //   'Drug Retailers',
  //   'Food Retailers & Wholesalers',
  //   'Apparel Retailers',
  //   'Broadline Retailers',
  //   'Home Improvement Retailers',
  //   'Specialized Consumer Services',
  //   'Specialty Retailers',
  //   'Broadcasting & Entertainment',
  //   'Media Agencies',
  //   'Publishing',
  //   'Airlines',
  //   'Gambling',
  //   'Hotels',
  //   'Recreational Services',
  //   'Restaurants & Bars',
  //   'Travel & Tourism',
  //   'Fixed Line Telecommunications',
  //   'Mobile Telecommunications',
  //   'Conventional Electricity',
  //   'Alternative Electricity',
  //   'Gas Distribution',
  //   'Multiutilities',
  //   'Water',
  //   'Banks',
  //   'Full Line Insurance',
  //   'Insurance Brokers',
  //   'Property & Casualty Insurance',
  //   'Reinsurance',
  //   'Life Insurance',
  //   'Real Estate Holding & Development',
  //   'Real Estate Services',
  //   'Industrial & Office REITs',
  //   'Retail REITs',
  //   'Residential REITs',
  //   'Diversified REITs',
  //   'Specialty REITs',
  //   'Mortgage REITs',
  //   'Hotel & Lodging REITs',
  //   'Asset Managers',
  //   'Consumer Finance',
  //   'Specialty Finance',
  //   'Investment Services',
  //   'Mortgage Finance',
  //   'Equity Investment Instruments',
  //   'Nonequity Investment Instruments',
  //   'Computer Services',
  //   'Internet',
  //   'Software',
  //   'Computer Hardware',
  //   'Electronic Office Equipment',
  //   'Semiconductors',
  //   'Telecommunications Equipment'
  // ];

  typesList = [
    'Listed',
    'Unlisted'
  ];

  countriesList = [];

  // countriesList = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Holy See', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshal Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Saint Pierre and Miquelon', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Turks and Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands (UK)', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'];

  strippersList = [
    'Private Limited Company\\b',
    'GmbH & Co\\. Beteiligungs KG\\b',
    'mbH & Co\\. KG\\b',
    'GmbH & Co\\. KG\\b',
    'GMBH & CO\\. KG\\b',
    'BV & Co\\. KG\\b',
    'CO LLC\\b',
    'CO\\., LTD\\.',
    'CO\\., INC\\.',
    'PTE\\. LIMITED\\b',
    'PTE\\. LTD\\b',
    'Pte\\. Ltd\\b',
    'Pty Ltd\\b',
    'Group GmbH\\b',
    'Holdings Group\\b',
    'Holding Group\\b',
    'Group\\b',
    'GROUP\\b',
    'Holdings\\b',
    'Holding\\b',
    'HOLDING\\b',
    'Corporation\\b',
    'CORPORATION\\b',
    'CORP\\.',
    'Corp\\.',
    'CORP\\b',
    'Corp\\b',
    'GMBH\\b',
    'GmbH\\b',
    'PLC\\b',
    'Plc\\b',
    'plc\\b',
    'LTD\\.',
    'LTD\\b',
    'Ltd\\.',
    'Ltd\\b',
    'Inc\\.',
    'Inc\\b',
    'S\\.A\\.',
    'SA\\b',
    'AG\\b',
    'LLC\\b',
    'LIMITED\\b',
    'Limited\\b',
    'CO\\.',
    'SRL\\b',
    'PTE\\.',
    'L\\.P\\.',
    'LP\\b',
    'Partners\\b',
    'Pty\\b',
    'B\\.V\\.',
    'INCORPORATED\\b',
    'Incorporated\\b',
    'INC\\.',
    'INC\\b',
    'SIA\\b',
    'L\\.L\\.C\\.',
    'N\\.V\\.',
    'NV\\b',
    'Aktiengesellschaft\\b'
  ];

  // single request
  data = {
    legalName: '',
    sector: '',
    website: '',
    surfaceForms: [],
    type: '',
    city: '',
    country: '',
    isin: '',
    ceo: '',
    message: ''
  };
  createQuery: boolean;

  // chip list related parameters
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  // autocomplete options
  myControlSectors = new UntypedFormControl();
  filteredSectors: Observable<any>;
  myControlCountries = new UntypedFormControl();
  filteredCountries: Observable<any>;

  // queries options
  selectedCollections = [];
  collectionsList = [];

  // uploaded excel file's content
  fileData: any;
  fileColumns = [];

  // number of requested entities
  entitiesNumber = 1;

  // columns mapping for multiple requests from excel file
  dataFile = {
    legalName: undefined,
    sector: undefined,
    website: undefined,
    surfaceForms: undefined,
    type: undefined,
    city: undefined,
    country: undefined,
    isin: undefined,
    ceo: undefined,
    message: undefined
  };

  /**
  *constructor
  */
  constructor(
    @Inject(MAT_DIALOG_DATA) public nameInput,
    public dialog: MatDialog,
    public auth: AuthService,
    private yukkApi: YukkApi,
    private router: Router,
    public config: ConfigService,
    public snackBar: MatSnackBar,
  ) {

    if (window.Cypress) {
      console.log('EntityaskComponent running Cypress');
      window.EntityaskComponent = this;
    }

    this.yukkApi.getSubsectors().subscribe(res => {
      this.sectorsList = res.entities.map(el => {
        return el.name;
      });

      this.filteredSectors = this.myControlSectors.valueChanges
        .pipe(
          tap(value => {
            this.data.sector = value;
          }),
          startWith(''),
          map(value => value ? this.elementMatches(this.sectorsList, value) : this.sectorsList.slice())
        );

    });

    this.yukkApi.getCountries().subscribe(res => {
      this.countriesList = res.entities.map(el => {
        return el.name;
      });

      this.filteredCountries = this.myControlCountries.valueChanges
        .pipe(
          tap(value => {
            this.data.country = value;
          }),
          startWith(''),
          map(value => value ? this.elementMatches(this.countriesList, value) : this.countriesList.slice())
        );

    });

    this.auth.getGroupsQuery().subscribe(result => {
      this.collectionsList = result;
    });

    this.data.legalName = nameInput;
    this.createQuery = true;

  }

  /**
   * returns matching items
   */
  elementMatches(options, value) {
    const filterValue = value.toLowerCase();
    return options.filter(item => item.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(element) {
    return element ? element : '';
  }

  /**
   * remove unwanted strings from text
   */
  stripLegalName(name) {
    const expStr = this.strippersList.join('|');
    return name.replace(new RegExp('\\b(' + expStr + ')', 'gi'), ' ').replace(/\s{2,}/g, ' ').trim();
  }

  /**
  * start submit event
  */
  iSubmit() {

    if (this.headerTab === 'single') {

      if (this.isValid()) {
        const user = this.auth.authToken();
        const data = [{
          legal_name: this.data.legalName,
          additional_information: {
            time: Date.now(),
            email: user.email,
            project: this.config.appConfig.routing.project,
            message: this.data.message,
            sector: this.data.sector,
            website: this.data.website,
            surfaceForms: this.data.surfaceForms.join(),
            type: this.data.type,
            city: this.data.city,
            country: this.data.country,
            isin: this.data.isin,
            ceo: this.data.ceo
          }
        }];
        this.auth.addRequestEntity(data).subscribe(result => {
          this.dialog.closeAll();
          if (this.createQuery) {
            const query = {
              operator: 'and',
              filters: [],
              groups: [{
                operator: 'or',
                slop: 5,
                filters: [{
                  negated: false,
                  field: 'text',
                  name: '',
                  value: this.data.legalName.trim(),
                  input: this.data.legalName.trim()
                }],
                groups: []
              }]
            };
            const strippedLegalName = this.stripLegalName(this.data.legalName);
            if (strippedLegalName && strippedLegalName.trim()) {
              query.groups[0].filters.push(
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: strippedLegalName.trim(),
                  input: strippedLegalName.trim()
                }
              );
            }
            if (this.data.surfaceForms && (this.data.surfaceForms.length !== 0)) {
              this.data.surfaceForms.forEach(item => {
                if (item && item.trim()) {
                  query.groups[0].filters.push(
                    {
                      negated: false,
                      field: 'text',
                      name: '',
                      value: item.trim(),
                      input: item.trim()
                    }
                  );
                }
              });
            }
            if (this.data.isin && this.data.isin.trim()) {
              query.groups[0].filters.push(
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: this.data.isin.trim(),
                  input: this.data.isin.trim()
                }
              );
            }
            if (this.data.ceo && this.data.ceo.trim()) {
              query.groups[0].filters.push(
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: this.data.ceo.trim(),
                  input: this.data.ceo.trim()
                }
              );
            }
            const data2 = {
              groups: this.selectedCollections,
              name: this.data.legalName,
              query: query
            };
            this.auth.addQuery(data2).subscribe(() => {
              this.snackBar.open('New entity request sent, new query added to the Collections Board', 'OK', { duration: 5000 });
              this.router.navigate([], {
                queryParams: {
                  update: Math.random()
                }, queryParamsHandling: 'merge'
              });
            });
          } else {
            this.snackBar.open('New entity request sent', 'OK', { duration: 5000 });
          }
        });
      } else {
        alert('Error: all of the required fields must be fulfilled.');
      }

    } else if (this.headerTab === 'upload') {

      if (this.fileData && (this.fileData.length < 1000)) {
        const user = this.auth.authToken();
        const mappedColumns = [];
        const additionalColumns = [];
        const queries = [];
        Object.keys(this.dataFile).forEach(item => {
          if (this.dataFile[item] !== undefined) {
            mappedColumns.push(this.dataFile[item]);
          }
        });
        for (let i = 0; i < this.fileColumns.length; i++) {
          if (!mappedColumns.includes(i)) {
            additionalColumns.push(i);
          }
        }
        const requestedEntities = [];
        for (let j = 1; j < this.fileData.length; j++) {
          if (this.fileData[j].length > 0) {
            const entity = {
              legal_name: (this.dataFile['legalName'] !== undefined) ? this.fileData[j][this.dataFile['legalName']] : '',
              additional_information: {
                time: Date.now(),
                email: user.email,
                project: this.config.appConfig.routing.project,
                message: (this.dataFile['message'] !== undefined) ? this.fileData[j][this.dataFile['message']] : '',
                sector: (this.dataFile['sector'] !== undefined) ? this.fileData[j][this.dataFile['sector']] : '',
                website: (this.dataFile['website'] !== undefined) ? this.fileData[j][this.dataFile['website']] : '',
                surfaceForms: (this.dataFile['surfaceForms'] !== undefined) ? this.fileData[j][this.dataFile['surfaceForms']] : '',
                type: (this.dataFile['type'] !== undefined) ? this.fileData[j][this.dataFile['type']] : '',
                city: (this.dataFile['city'] !== undefined) ? this.fileData[j][this.dataFile['city']] : '',
                country: (this.dataFile['country'] !== undefined) ? this.fileData[j][this.dataFile['country']] : '',
                isin: (this.dataFile['isin'] !== undefined) ? this.fileData[j][this.dataFile['isin']] : '',
                ceo: (this.dataFile['ceo'] !== undefined) ? this.fileData[j][this.dataFile['ceo']] : ''
              }
            };
            additionalColumns.forEach(item => {
              entity.additional_information[this.fileColumns[item]] = this.fileData[j][item];
            });
            requestedEntities.push(entity);
            if (this.createQuery) {
              const query = {
                operator: 'and',
                filters: [],
                groups: [
                  {
                    operator: 'or',
                    slop: 5,
                    filters: [],
                    groups: []
                  }
                ]
              };
              if (entity.legal_name && entity.legal_name.trim()) {
                query.groups[0].filters.push(
                  {
                    negated: false,
                    field: 'text',
                    name: '',
                    value: entity.legal_name.trim(),
                    input: entity.legal_name.trim()
                  }
                );
              }
              const strippedLegalName = this.stripLegalName(entity.legal_name);
              if (strippedLegalName && strippedLegalName.trim()) {
                query.groups[0].filters.push(
                  {
                    negated: false,
                    field: 'text',
                    name: '',
                    value: strippedLegalName.trim(),
                    input: strippedLegalName.trim()
                  }
                );
              }
              if (entity.additional_information.surfaceForms && (entity.additional_information.surfaceForms.length !== 0)) {
                entity.additional_information.surfaceForms.split(',').forEach(item => {
                  if (item && item.trim()) {
                    query.groups[0].filters.push(
                      {
                        negated: false,
                        field: 'text',
                        name: '',
                        value: item.trim(),
                        input: item.trim()
                      }
                    );
                  }
                });
              }
              if (entity.additional_information.isin && entity.additional_information.isin.trim()) {
                query.groups[0].filters.push(
                  {
                    negated: false,
                    field: 'text',
                    name: '',
                    value: entity.additional_information.isin.trim(),
                    input: entity.additional_information.isin.trim()
                  }
                );
              }
              if (entity.additional_information.ceo && entity.additional_information.ceo.trim()) {
                query.groups[0].filters.push(
                  {
                    negated: false,
                    field: 'text',
                    name: '',
                    value: entity.additional_information.ceo.trim(),
                    input: entity.additional_information.ceo.trim()
                  }
                );
              }
              const queryObject = {
                groups: this.selectedCollections,
                name: entity.legal_name ? entity.legal_name : '',
                query: query
              };
              if (query.groups[0].filters.length > 0) {
                queries.push(queryObject);
              }
            }
          }
        }
        this.auth.addRequestEntity(requestedEntities).subscribe(result => {
          this.dialog.closeAll();
          if (this.createQuery && (queries.length !== 0)) {
            this.auth.addQueries(queries).subscribe(() => {
              this.snackBar.open('New entity request sent, new query added to the Collections Board', 'OK', { duration: 5000 });
              this.router.navigate([], {
                queryParams: {
                  update: Math.random()
                }, queryParamsHandling: 'merge'
              });
            });
          } else {
            this.snackBar.open('New entity request sent', 'OK', { duration: 5000 });
          }
        });
      } else if (this.fileData && (this.fileData.length >= 1000)) {
        alert('Error: too many entities in the uploaded file. The number of requested entities should not exceed 1000.');
      } else {
        alert('Error: no valid excel file uploaded.');
      }

    }

  }

  /**
   * request entity data validation
   */
  isValid() {
    if (!this.data.legalName) { return false; }
    if (!this.data.sector) { return false; }
    if (!this.data.website) { return false; }
    if (!this.data.type) { return false; }
    if (!this.data.country) { return false; }
    return true;
  }

  /**
   * add chip
   * @param event
   */
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.data.surfaceForms.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }

  /**
   * remove chip
   * @param form
   */
  remove(form): void {
    const index = this.data.surfaceForms.indexOf(form);

    if (index >= 0) {
      this.data.surfaceForms.splice(index, 1);
    }
  }

  /**
   * import requested entities from file
   */
  uploadFile(event) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) { throw new Error('Cannot use multiple files'); }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      this.fileData = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
      this.fileColumns = this.fileData[0];
      this.selectedCollections = [];
      this.entitiesNumber = this.fileData.length - 1;
    };
    reader.readAsBinaryString(target.files[0]);
  }

  /**
   * runs when switching between single entity and file upload modes
   */
  onHeaderTabChange() {
    if (this.headerTab === 'single') {
      this.entitiesNumber = 1;
    } else if (this.headerTab === 'upload') {
      this.selectedCollections = [];
    }
  }

}
